import { render } from "./CockFt.vue?vue&type=template&id=393a454d&scoped=true"
import script from "./CockFt.vue?vue&type=script&lang=js"
export * from "./CockFt.vue?vue&type=script&lang=js"

import "./CockFt.vue?vue&type=style&index=0&id=393a454d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-393a454d"

export default script